import gql from 'graphql-tag'

export const GET_CONFIG = gql`
  query getConfig {
    getConfig {
      shopConfig
      featureFlags
    }
  }
`
